import { MyApp } from 'app/MyApp';

// eslint-disable-next-line import/no-unassigned-import
import 'app/MyApp/global.scss';

export default MyApp;
